/**
 * A skill
 * @class
 * @property {string} category The category of the skill
 * @property {string} skill The name of the skill
 * @property {number} level The level of the skill
 */

export class Skill {
    category: string;
    skill: string;
    name: string = "";
    level: number = 0;
    isRequired?: boolean;
    constructor(category: string, skill: string, level: number = 0, isRequired: boolean = true) {
        this.category = category;
        this.skill = skill;
        this.level = level;
        this.isRequired = isRequired;
        if (this.name == '')
            this.name = category + " - " + skill;
    }

    /**
     * Get the skill level as a string
     * @returns {string} A string representation of the skill
     */
    toString() {
        return this.skill + " (" + this.level + ")";
    }


}
